import { CheckCircleIcon, PencilIcon, PlayIcon } from '@heroicons/react/24/outline'

export function StatusBadge({ status, t }) {
  const config = {
    draft: { icon: PencilIcon, bg: 'bg-gray-100', text: 'text-gray-700', label: t('programs.status.draft') },
    active: { icon: PlayIcon, bg: 'bg-blue-100', text: 'text-blue-700', label: t('programs.status.active') },
    submitted: { icon: CheckCircleIcon, bg: 'bg-green-100', text: 'text-green-700', label: t('programs.status.submitted') }
  }

  const { icon: Icon, bg, text, label } = config[status] || config.draft

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${bg} ${text}`}>
      <Icon className="h-3.5 w-3.5 mr-1" />
      {label}
    </span>
  )
}
